import React, {Component} from 'react';
import {Popconfirm, Card, Icon, message, Empty, Avatar, Tooltip, Button, Drawer, Input, Form, Modal,Dropdown,Menu} from 'antd';
import {uuid} from "../../../utils";
import {deleteMaterialById, deleteStuffById, getRedirectXiumi, getStuffById} from "../../../actions/weiChat";
import { FormOutlined ,EyeOutlined} from "@ant-design/icons";
import {EditableTagGroup} from "../../../components/editableTagGroup";
import ContentModal from "./../../../containers/contentModal";
import del from './images/delete.png'
import edit from './images/edit.png'
import checkIcon from './images/checkIcon.png'
import RelationSelectTopicDetail from '../manuscriptPool/RelationSelectTopicDetail'
import BaseComponent from "../../../base/BaseComponent";
export class StuffCard extends BaseComponent {

    constructor(props){
        super(props);
        this.state = {
            fromStuff: props.fromStuff, // 区别是来自素材列表还是图文列表
            stuffId: props.stuffId,
            formId: props.formId,
            showLock: props.showLock,
            materialId: props.id || 0,
            updateDate: window.formatDate(props.updateTime),
            statusName : props.statusName,
            stuffList : props.stuffList,
            mediaCode: props.mediaCode,
            isEditMaterial:props.isEditMaterial,//是否是编辑状态
            isMerge: props.isMerge,//是否是合成状态
            currentIndex: this.props.currentIndex,
            checkedStuffId:0,
            openCheckedMode: props.openCheckedMode,
            isOpenEditAttr: props.isOpenEditAttr,
            edit: props.edit,
            canEdit: props.canEdit,
            message: props.message,
            contentModalVisible: false,
            viewStuffId : 0,
            disable:props.disable //控制当前是否为禁用状态
        };
        this.reloadStuffList = props.reloadStuffList;
        this.reloadMaterialList = props.reloadMaterialList;
        this.editMaterial = props.editMaterial;
    }

    reloadMaterialList = () =>{};

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            stuffList : nextProps.stuffList,
            statusName : nextProps.statusName,
            updateDate: window.formatDate(nextProps.updateTime),
            canEdit: nextProps.canEdit,
            currentIndex: nextProps.currentIndex
        });
    }

    reloadStuffList = () =>{};

    editStuff = () =>{
        window.weChatEditCallBackParam = true;
        window.weChatEditCallBack = this.reloadStuffList;
        let {formId, mediaCode, stuffId} = this.state;
        if(formId){
            getRedirectXiumi({"mediaId": formId,"currentMediaCode":mediaCode}, (res) => {
                window.open(res);
            });
            window.addEventListener('message',function(e){
                if(e.data === 'close'){
                    window.weChatEditCallBack(window.weChatEditCallBackParam);
                }
            },false);
        }else {
            let url = '#/wechat/135Edit/'+ mediaCode + '/' + stuffId;
            window.open(url);
        }
    };

    // editMaterial = () =>{};

    // deleteStuff = ()=>{
    //     window.loading.show();
    //     deleteStuffById({"stuffId":parseInt(this.state.stuffId)}, (res) =>{
    //         window.loading.hide();
    //         if(res){
    //             message.success('删除成功',1, ()=>{
    //                 this.reloadStuffList(true);
    //             });
    //         }else {
    //             message.error('删除失败');
    //         }
    //     });
    // };
    // 删除
    deleteById=()=>{
        let params={'materialId':this.state.materialId};
        this.request({
            url:'/cm-sites-pms/material/deleteById',
            method:'post',
            // contentType:'json',
            body:params,
            callBack:(res)=>{
                if(res){
                    message.success('删除成功',1, ()=>{
                        this.setState({});
                        this.reloadMaterialList("",true);
                    });
                }
            },
            errorCallBack:()=>{}
        })
    };
    deleteMaterial = ()=>{
        window.loading.show();
        this.deleteById({"materialId":parseInt(this.state.materialId)}, (res) =>{
            window.loading.hide();
            if(res){
                message.success('删除成功',1, ()=>{
                    this.reloadMaterialList("",true);
                });
            }else {
                message.error('删除失败');
            }
        });
    };

    setCheckedStuffId(id){
        if(this.props.openCheckedMode){
            if(this.state.checkedStuffId === id){
                return;
            }
            this.setState({
                checkedStuffId: id
            })
        }
    }

    viewStuff = (stuffId) =>{
        //编辑时候不看详情
        if(this.props.isOpenEditAttr){
          this.state.contentModalVisible=false;
        }else{
            // this.state.contentModalVisible=true;
        }

        // this.refs["stuffId" + stuffId].viewStuff();
        this.setState({
           // contentModalVisible: true,
            viewStuffId: stuffId
        })
    };

    review=(stuffId)=>{
        // this.state.contentModalVisible=true;
        this.setState({
            // contentModalVisible: true,
            viewStuffId: stuffId
        });
    };

    relation=(stuffId)=>{
        this.props.relation&& this.props.relation(stuffId)
    };

    onCancel = () =>{
        this.setState({
            contentModalVisible : false
        })
    };

    render() {
        let bodyStyle = {
            padding: "0px 16px"
        };
        if(this.props.isEditMaterial === true) {
            bodyStyle = {
                padding: "24px 24px 0px"
            }
        }
        let {disable} = this.props;
        return (this.state.stuffList && this.state.stuffList.length === 0&&!this.props.isOpenEditAttr ? <Empty/> :
            <div style={{ boxShadow:'0 3px 15px rgba(0, 0, 0, 0.08)'}}>
                {this.props.isEditMaterial?null:<span style={{ background: 'rgba(0, 80, 179, 0.04)', padding: '8px 16px', textAlign: 'start', display: 'block', cursor:'pointer', fontFamily: 'MicrosoftYaHei', color: 'rgba(0, 0, 0, 0.65)', fontSize: '12px'}}>{this.state.statusName}</span>}
                <Card
                    title={
                        this.state.isEditMaterial ?
                            (this.state.isMerge ? "" : <span style={{
                                fontFamily: 'MicrosoftYaHei',
                                color: 'rgba(0, 0, 0, 0.45)',
                                fontSize: '14px'
                            }}>更新于：{this.state.updateDate}</span>) :
                            <span style={{
                                fontFamily: 'MicrosoftYaHei',
                                color: 'rgba(0, 0, 0, 0.45)',
                                fontSize: '14px'
                            }}>{"更新于：" + this.state.updateDate}</span>
                    }
                    headStyle={{fontSize: "12px", padding: "0 16px", border: 'none'}}
                    bodyStyle={bodyStyle}
                    style={{position: "static"}}
                    bordered={false}
                    extra={
                        disable?null:(
                            this.state.isEditMaterial ? (this.state.isMerge ? "" :
                                <Button onClick={() => this.viewStuff(this.state.stuffId)} type="primary"
                                        size={"small"}>查看</Button>) :
                                (this.state.showLock ?
                                    <Tooltip placement="top" title={this.state.message || "查看"}><EyeOutlined
                                        style={{cursor: "pointer"}}
                                        onClick={() => this.viewStuff(this.state.stuffId)}/></Tooltip> :
                                    (this.state.fromStuff ?
                                        <span>
                                   <Tooltip placement="top" title={"编辑"}>
                                       <Icon type="edit" style={{
                                           cursor: "pointer",
                                           width: '15px',
                                       }} onClick={() => {
                                           this.props.editMaterial(this.state.materialId);
                                       }}/>
                                   </Tooltip>
                                    <Tooltip placement="top" title={"删除"}>
                                        <Popconfirm placement="right" title={"确认删除吗？"}
                                                    onConfirm={this.deleteById.bind(this)} okText="确认" cancelText="取消">
                                            <Icon type="delete"
                                                  style={{marginLeft: "10px", cursor: "pointer", width: '15px',}}/>
                                        </Popconfirm>
                                    </Tooltip>
                                  </span> :
                                        <span>
                                      <Tooltip placement="top" title={"编辑"}><Icon type="edit" style={{
                                          cursor: "pointer",
                                          width: '15px',
                                      }} onClick={() => {
                                          this.props.editMaterial(this.state.materialId);
                                      }}/></Tooltip>
                                            {
                                                this.state.statusName && this.state.statusName === '草稿' ?
                                                    <Tooltip placement="top" title={"删除"}>
                                                        <Popconfirm placement="right" title={"确认删除吗？"}
                                                                    onConfirm={this.deleteMaterial.bind(this)} okText="确认"
                                                                    cancelText="取消">
                                                            <Icon type="delete"
                                                                  style={{
                                                                      marginLeft: "10px",
                                                                      cursor: "pointer",
                                                                      width: '15px',
                                                                  }}/>
                                                        </Popconfirm>
                                                    </Tooltip> : ""
                                            }
                                  </span>))
                        )
                    }
                >
                    {this.state.stuffList && this.state.stuffList.map((item, index) => {
                        // item.uuid = item.uuid?item.uuid:uuid();
                        let checkData = this.props.checkData || null;
                        let checkKey = item?.checkKey || "";
                        let checkNum = 0;
                        if(checkData && checkKey) {
                            for(let i in checkData) {
                                if(i.indexOf(checkKey)>-1 && checkData[i]?.length > 0) {
                                    checkNum = checkNum + checkData[i]?.length
                                }
                            }
                        }
                        return <Stuff dbInfo={item}
                                      index={index}
                                      checkNum={checkNum}
                                      itemClick={()=>{this.props.itemClick&&this.props.itemClick(item,index)}}
                                      setCheckedStuffId={this.setCheckedStuffId.bind(this)}
                                      openCheckedMode={this.props.openCheckedMode}
                                      ref={"stuffId"+item.id}
                                      delStuff={this.props.delStuff}
                                      upStuff={this.props.upStuff}
                                      downStuff={this.props.downStuff}
                                      viewStuff={this.viewStuff}
                                      review={this.review}
                                      relation={this.relation}
                                      isAdd={this.props.isAdd}
                                      chooseTopicBtn={this.props.chooseTopicBtn}
                                      checked={this.state.currentIndex === index }
                                      //checked={this.state.checkedStuffId!==0 && this.state.checkedStuffId===item.id} reloadStuff={this.props.reloadStuff}
                                      contentHeight={this.props.contentHeight}
                                      isOpenEditAttr={this.props.isOpenEditAttr}
                                      addStuff={this.props.addStuff}
                                      key={index}
                                      isEditMaterial={this.state.isEditMaterial}
                                      type={index === 0?"big":"small"}
                                      {...item}
                                      canEdit={this.state.canEdit}
                                      newSecondSelectColor={this.props.newSecondSelectColor}
                                      />
                    })}
                    {/*新功能添加的东西*/}
                    {this.state.stuffList.length<8&&this.props.isOpenEditAttr?
                        <Dropdown overlay={<div style={{textAlign:'center'}}>
                            <div><Button onClick={()=>{this.props.addPic&&this.props.addPic()}}>创建图文</Button></div>
                            <div><Button onClick={()=>{this.props.choosePic&&this.props.choosePic()}}>选择图文</Button></div>
                        </div>} placement="bottomCenter">
                            <div style={{cursor:'pointer',width:'100%',position:'relative',height:65,lineHeight:"65px",padding:5, textAlign: 'center', borderTop:this.state.stuffList.length? "1px solid rgba(0, 0, 0, 0.15)":null}}><Icon type="plus" style={{verticalAlign:"middle",margin:'-2px 3px 0px 0px'}}/> 新建消息</div>
                        </Dropdown>
                        :null}
                </Card>

                <Modal title={"内容详情"} destroyOnClose={true} visible={this.state.contentModalVisible} bodyStyle={{height:"78vh"}} onCancel={this.onCancel.bind(this)} footer={null}>
                    <ContentModal materialId={this.state.materialId} viewStuffId={this.state.viewStuffId} currentItem={this.props.currentItem}/>
                </Modal>
            </div>
        );
    }
}


StuffCard.defaultProps = {
    edit: false,
    openCheckedMode: false,
    isMerge: false,
    isOpenEditAttr: false
};

class Stuff extends Component {

    info = this.props.dbInfo;

    constructor(props){
        super(props);
        this.state = {
            title : props.title,
            titlePic: props.titlePic,
            type: props.type,
            checkNum: props.checkNum,
            checked: props.checked,
            stuffId: props.id,
            isOpenEditAttr: props.isOpenEditAttr,//是否开启编辑属性的功能
            materialId : props.materialId,
            showAttr: false,//是否显示按钮区域
            canEdit: props.canEdit
        };

        if(props.onRef){
            props.onRef(this);
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState(prevState=>{
			return {
				...prevState,
				title : nextProps.title,
				titlePic: nextProps.titlePic,
				type: nextProps.type,
                checkNum: nextProps.checkNum,
				checked: nextProps.checked,
				stuffId: nextProps.id,
				isOpenEditAttr: nextProps.isOpenEditAttr,//是否开启编辑属性的功能
				materialId : nextProps.materialId,
			}
        })
    }
    remove(){
        this.props.delStuff(this.props.dbInfo);
    }

    up(){
        this.props.upStuff(this.props.dbInfo);
    }

    down(){
        this.props.downStuff(this.props.dbInfo);
    }

    reload(data){
        this.props.reloadStuff(data);
    }

    view(){
        this.props.review(this.state.stuffId)
        //this.props.viewStuff(this.state.stuffId);
    }
    //关联选题
    relation(){
      //  this.SelectManuscriptPool.showTask({ taskTitle: '关联选题', topBtn: true }) 
    this.props.relation(this.state.stuffId)
    }

    // viewStuff = () => {
    //     let content = "#/wechat/weixing/edit/"+ this.state.materialId +"/"+ this.state.stuffId;
    //     let win = window.top || window;
    //     let maxWidth = 550;
    //     let width = win.document.body.clientWidth * 0.9;
    //     width = width > maxWidth? maxWidth: width;
    //     width = width + "px";
    //     let height = win.document.body.clientHeight * 0.9 + "px";
    //     win.layer.open({
    //         type: 2,
    //         zIndex: 29991015,
    //         area: [width, height],
    //         title: '内容详情',
    //         content: content
    //     });
    // };

    showAttrArea = ()=>{
        this.setState({
            showAttr: true
        })
    };

    closeAttrArea = ()=>{
        this.setState({
            showAttr: false
        });
    };

    updateAuthor(e){
        let author = e.target.value;
        this.info.author = author;
        this.props.reloadStuff(this.info);
    }

    updateUrl(e){
        let url = e.target.value;
        if(url && !/^(http|https):\/\/.+/.test(url)){
            message.warn("原文链接不合法");
        }
        this.info.url = url;
        this.props.reloadStuff(this.info);
    }

    updateStuffTags(tags){
        this.info.labelNames = tags;
        this.props.reloadStuff(this.info);
    }
    renderAttr(){
        if(this.state.isOpenEditAttr && this.state.checked){
            return (<div style={{overflow: "hidden",textAlign:"left"}}>
                <img src={"images/icon-close.png"} style={{cursor:"pointer",position:"absolute", right:"0px", top:this.props.contentHeight/2-25+"px"}} onClick={this.showAttrArea.bind(this)}/>
                <Drawer
                    getContainer={false}
                    style={{ position: 'absolute',display:this.state.showAttr?'block':'none'}}
                    title=""
                    placement={"right"}
                    closable={false}
                    onClose={this.closeAttrArea}
                    visible={this.state.showAttr}
                >
                    <WrappedStuffAttrForm stuff={this.info} ref={that=>this.wrappedStuffAttrForm=that} updateStuffTags={this.updateStuffTags.bind(this)} updateAuthor={this.updateAuthor.bind(this)} updateUrl={this.updateUrl.bind(this)} />
                </Drawer>
              
            </div>);
        }
    }

    render() {
        return (this.state.type === "big" ? <BigStuff {...this.props} {...this.state} itemClick={()=>{this.props.itemClick&&this.props.itemClick()}} />: <SmallStuff itemClick={()=>{this.props.itemClick&&this.props.itemClick()}} {...this.props} {...this.state}/>)
    }

}
Stuff.defaultProps = {
    type: "big",
    addStuff:()=>{},
    checked: false,
    titlePic: '',
    // titlePic : "/cm-sites/images/material/timg.jpg",
    index: 0//位置默认为第一个
};


class BigStuff extends Stuff{

    //下面是展示的每一项

    onClick(){
        this.props.itemClick&&this.props.itemClick();//点击每一项回填数据
         this.props.addStuff(this.props.dbInfo);
         if(this.props.openCheckedMode){
           this.props.setCheckedStuffId(this.props.id);
         }
        this.props.viewStuff(this.state.stuffId);
    }

    topicDetail = () => {
        if(this.info.topicId){
            this.RelationSelectTopicDetail.selectTopicDetailDetailShow(this.info.topicId)   
        }
    };


    render() {

        let height = "200px";
        let picDivStyle = {
            // cursor:"pointer",
            // height,
            paddingBottom: "42.55319149%",
            background: "url("+ this.state.titlePic + ") center center / cover no-repeat",
            // backgroundSize: "cover"
        };
        let titleDivStyle = {
            position:"absolute",
            fontFamily: 'MicrosoftYaHei',
	        fontSize: '15px',
            bottom:"3px",
            left:"5px",
            color:"white",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display:"-webkit-box",
            WebkitLineClamp:2,
            WebkitBoxOrient: "vertical"
        };

        return (
            <div>
                 {
                        this.state.checked&&this.props.isAdd&&this.props.isAddTopic&&this.props.chooseTopicBtn ?
                            <div onClick={() => this.topicDetail()}  style={{ cursor:'pointer', background: this.props.newSecondSelectColor, opacity: '0.9', padding: '5px 0px', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', color: '#fff' }}>
                                <div><Avatar size={30} icon={'reconciliation'} style={{ background: this.props.newSecondSelectColor }} /></div>
                                <div>{this.info.topicName}</div>
                            </div> 
                       : ''
                    }
                <div style={{position: 'relative',marginBottom:"15px", textAlign:"left",border:`3px solid ${this.state.checked?this.props.newSecondSelectColor: 'transparent'}`}}>
                    <div onClick={()=>this.onClick()} style={{cursor: this.props.isEditMaterial ? "pointer" : ""}}>
                        <div style={picDivStyle}/>
                        <div style={{position:"absolute", bottom:"0px", left:"0px", width:"100%", background:"#3f4658",opacity:"0.6",height:"50px"}}/>
                        {this.renderCheckIcon()}
                        <span style={titleDivStyle}>{this.props.title}</span>
                    </div>
                    {this.state.checked && this.state.canEdit?<div ><OperateBar stuff={this.info} remove={this.remove.bind(this)} up={this.up.bind(this)} view={this.view.bind(this)}
                                                                relation={this.relation.bind(this)} {...this.props}
                                                          down={this.down.bind(this)} reload={this.reload.bind(this)} stuffHeight={height} /></div>:""}
                </div>
                <RelationSelectTopicDetail
                    ref={RelationSelectTopicDetail => {this.RelationSelectTopicDetail = RelationSelectTopicDetail}} />
               {/* {this.renderAttr()}*/}
            </div>
        )
    }

    renderCheckIcon = () => {
        let checkNum = this.props.checkNum;
        if(checkNum > 0) {
            return <div style={{position:"absolute", top:-7, left:-22}}>
                <img src={checkIcon} style={{width:16}}/>
            </div>
        }
        return ""
    };

}

class SmallStuff extends Stuff{

    onClick(){
        this.props.itemClick&&this.props.itemClick();
         if(this.props.openCheckedMode){
             this.props.setCheckedStuffId(this.props.id);
         }
        this.props.viewStuff(this.state.stuffId);
    }

    height = "90px";

    getCheckedCss() {
        if (this.state.checked) {
            return {
                position: "relative",
                height: this.height,
                padding: "5px",
                paddingTop: "3px",
                border: `3px solid ${this.props.newSecondSelectColor}`,
                textAlign:"left"
            };
        } else {
            return {
                position: "relative",
                height: this.height,
                padding: "5px",
                paddingTop: "3px",
                border: `3px solid transparent`,
                // borderTopColor: "rgba(0, 0, 0, 0.15)",
                textAlign:"left"
            };
        }
    }
    topicDetail = () => {
        if(this.info.topicId){
            this.RelationSelectTopicDetail.selectTopicDetailDetailShow(this.info.topicId)   
        }
    };
    renderCheckIcon = () => {
        let checkNum = this.props.checkNum;
        if(checkNum > 0) {
            return <div style={{position:"absolute", top:8, left:-22}}>
                <img src={checkIcon} style={{width:16}}/>
            </div>
        }
        return ""
    };
    render() {
        let picDivStyle = {
            // cursor:"pointer",
            width: 64,
            height: 64,
            //background: "url("+ this.state.titlePic + ") center no-repeat",
            //backgroundSize: "cover",
            position: "absolute",
            right:"0px",
            // margin:"10px 0px",
            display:'flex',
            justifyContent: 'center',
            aliginItems: 'center'
        };
        let titleDivStyle = {
            width:"70%",
            padding:"5px",
            float:"left",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display:"-webkit-box",
            WebkitLineClamp:3,
            WebkitBoxOrient: "vertical",
            minHeight: "65px",
            fontFamily: 'MicrosoftYaHei',
            color:'#2a3a6b',
            fontSize: '15px',
            // cursor:"pointer",
        };

        return (
            <div>
                <div style={{height:1,backgroundColor:"#ebedf0"}}></div>
                <div style={this.getCheckedCss()}>
                    {this.renderCheckIcon()}
                    {
                        this.state.checked && this.props.isAdd && this.props.isAddTopic && this.props.chooseTopicBtn ?
                            <div onClick={() => this.topicDetail()} style={{
                                cursor: 'pointer',
                                background: this.props.newSecondSelectColor,
                                opacity: '0.9',
                                padding: '5px 0',
                                display: 'flex',
                                justifyContent: 'flex-start',
                                alignItems: 'center',
                                color: '#fff',
                                position: 'absolute',
                                width: 'calc( 100% + 6px )',
                                top: '-40px',
                                right: '-3px'
                            }}>
                                <div><Avatar size={30} icon={'reconciliation'}
                                             style={{background: this.props.newSecondSelectColor}}/></div>
                                <div style={{
                                    width: '100%',
                                    overflow: "hidden",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 1,
                                    WebkitBoxOrient: "vertical"
                                }}>{this.info.topicName}</div>
                            </div>
                            : ''
                    }
                    <div style={{cursor: this.props.isEditMaterial ? "pointer" : ""}}>
                        <div style={titleDivStyle} onClick={() => this.onClick()}>{this.props.title}</div>
                        <div style={picDivStyle} onClick={() => this.onClick()}>
                            {
                                this.state.titlePic ?
                                    <img style={{width: '100%', objectFit: 'cover'}} src={this.state.titlePic} alt=""/>
                                    : ""
                            }
                        </div>
                        {/* <div style={picDivStyle} onClick={()=>this.onClick()}/> */}
                    </div>
                    {this.state.checked && this.state.canEdit ?
                        <OperateBar vAlign={this.props.index > 4 ? "bottom" : "middle"} stuff={this.info}
                                    remove={this.remove.bind(this)} up={this.up.bind(this)} view={this.view.bind(this)}
                                    relation={this.relation.bind(this)} {...this.props}
                                    down={this.down.bind(this)} reload={this.reload.bind(this)}
                                    stuffHeight={this.height}/> : ""
                    }
                </div>
                <RelationSelectTopicDetail
                    ref={RelationSelectTopicDetail => {this.RelationSelectTopicDetail = RelationSelectTopicDetail}} />
                {/*去掉右侧弹窗*/}
               {/* {this.renderAttr()}*/}
            </div>
        )
    }
}


class OperateBar extends Component {

    constructor(props){
        super(props);
    }

    render() {
        let width = "50px";

        let num=3;//原来是6
        // if(this.props.isAdd&&this.props.isAddTopic&&this.props.chooseTopicBtn){
        //     num=3;
        // }else{
        //     num=3;
        // }
        const btnHeight = 30;
        let height = (btnHeight + 8 ) * num + 8 + "px";
        // let right = (parseInt(width) + 3 + 10 + 1 + 10)*-1 + "px";
        let right = (parseInt(width) + 3 + 24 + 13)*-1 + "px";

        let vAlign = (()=>{
            if(this.props.vAlign === "bottom"){
                return {bottom:"0px"};
            }else if(this.props.vAlign === "top"){
                return {top:"0px"};
            }else{
                return {top:(parseInt(height) - parseInt(this.props.stuffHeight))/-2 + "px"};
            }
        })();
        return (<div style={{position:"absolute", width, height,right,...vAlign,  border:"1px solid #e8e8e8", borderRadius:"50px", textAlign:"center"}}>
            <OperateBarBtn {...this.props} up={this.props.up} clickMethod={"arrowUp"} type={'arrow-up'} title={"上移"} />
            <OperateBarBtn {...this.props} down={this.props.down} clickMethod={"arrowDown"} type={'arrow-down'} title={"下移"} />
            {/*<OperateBarBtn {...this.props} reload={()=>this.props.reload(this.props.stuff.id)} clickMethod={"reload"} type={'reload'} title={"刷新"} />*/}
            {/*<OperateBarBtn {...this.props} view={this.props.view} clickMethod={"view"} type={'eye'} title={"查看"} />*/}
           {/* <OperateBarBtn {...this.props} clickMethod={"edit"} type={'edit'} title={"编辑"} />*/}
            {this.props.isAdd&&this.props.isAddTopic&&this.props.chooseTopicBtn?<OperateBarBtn {...this.props} relation={this.props.relation} clickMethod={"relation"} type={'reconciliation'} title={this.props.stuff.topicId ? "取消关联选题" : "关联选题"} />:null}

            <OperateBarBtn {...this.props} remove={this.props.remove} clickMethod={"delete"} type={'delete'} title={"移除"} />
        </div>);
    }
}
OperateBar.defaultProps = {
    vAlign:"middle"//默认居中显示， 再增加一个bottom和top显示。
}


class OperateBarBtn extends Component {

    constructor(props){
        super(props);
        this.state = {
            color: props.color,
        }
    }

    mouseOver(e){
        this.setState({
            color: "#000"
        })
    }

    mouseOut(e){
        this.setState({
            color: this.props.color
        })
    }

    onClick() {
        this[this.props.clickMethod](this.props);
    }

    relation(){
        this.props.relation()
    }

    arrowUp(){
        this.props.up();
    }

    arrowDown(){
        this.props.down();
    }

    reload(props){
        if(props){
            getStuffById({stuffId: props.stuff.id}, (data) => {
                props.reload(data);
            });
        }
    }

    view(){
        this.props.view();
    }

    edit(){
        let {fromId, mediaCode} = this.props.stuff;
        let stuffId = this.props.stuff.id;
        window.weChatEditCallBackParam = this.props;
        window.weChatEditCallBack = this.reload;
        if(fromId){
            getRedirectXiumi({"mediaId": fromId,"currentMediaCode":mediaCode}, (res) => {
                window.open(res);
            });
            window.addEventListener('message',function(e){
                if(e.data === 'close'){
                    window.weChatEditCallBack(window.weChatEditCallBackParam);
                }
            },false);
        }else {
            let url = '#/wechat/135Edit/'+ mediaCode + '/' + stuffId;
            window.open(url);
        }
    }

    delete(){
        this.props.remove();
    }

    render() {
        return (
            <Tooltip placement="right" title={this.props.title} style={{background:"#000"}}>
                <div onClick={()=>this.onClick()} style={{margin:"8px",cursor:"pointer"}} onMouseOut={(e)=>this.mouseOut(e)} onMouseOver={(e)=>this.mouseOver(e)}>
                    <Avatar size={30} icon={this.props.type} style={{background:this.state.color}} />
                </div>
            </Tooltip>);
    }
}
OperateBarBtn.defaultProps={
    color: "#e8e8e8",
}
export default StuffCard;


class StuffAttrForm extends Component{

    componentDidMount() {
        this.initFields(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.initFields(nextProps);
    }

    fieldData = {};
    stuff = {};

    initFields(props) {
        const { stuff } = props;
        const { setFields } = props.form;
        if(stuff && this.stuff !== stuff){
            this.stuff = stuff;
            this.fieldData = {
                author : { value: stuff.author },
                url : { value: stuff.url }
            };
            setFields(this.fieldData);
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return <Form>
            <Form.Item label="作者">
                {getFieldDecorator('author', {
                    rules: [{ required: false}],
                })(
                    <Input onBlur={(e)=>this.props.updateAuthor(e)} type="text"/>
                )}
            </Form.Item>
            <Form.Item label="原文链接">
                {getFieldDecorator('url', {
                    rules: [{ required: false, pattern: /^(http|https):\/\/.+/, message:"原文链接只能以http://或https://开头" }],
                })(
                    <Input onBlur={(e)=>this.props.updateUrl(e)} type="text"/>
                )}
            </Form.Item>
            <Form.Item label="标签">
                <EditableTagGroup onChange={this.props.updateStuffTags.bind(this)} ref={"editableTagGroup"} tags={this.stuff.labelNames} />
            </Form.Item>
        </Form>
    }
}
const WrappedStuffAttrForm = Form.create()(StuffAttrForm);